"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlanPaymentInterval;
(function (PlanPaymentInterval) {
    PlanPaymentInterval["MONTHLY"] = "MONTHLY";
    PlanPaymentInterval["YEARLY"] = "YEARLY";
})(PlanPaymentInterval = exports.PlanPaymentInterval || (exports.PlanPaymentInterval = {}));
//# sourceMappingURL=PlanPaymentInterval.js.map